import styled from 'styled-components';

import { COLORS } from '@r1-frontend/ui-react/assets/js/constants';
import { BaseButton } from '@r1-frontend/ui-react/components/buttons/baseButton';
import { FlexBoxCol, FlexBoxRow } from '@r1-frontend/ui-react/components/layouts/flexBoxGrid';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

import { breakPoints } from '~/src/features/domru-bonus/styled';

export const HeadWrapper = styled.div`
    width: 100%;
    height: 600px;
    margin-bottom: 124px;
    background: url('/static/images/loyalty/domru-bonus/head-bg.png') 0 0 / cover no-repeat;

    @media (max-width: ${breakPoints.sDesktop}) {
        height: 510px;
        margin-bottom: 116px;
    }

    @media (max-width: ${breakPoints.laptop}) {
        height: 380px;
        margin-bottom: 111px;
    }

    @media (max-width: ${breakPoints.tablet}) {
        height: 300px;
        margin-bottom: 64px;
    }

    @media (max-width: ${breakPoints.mobile}) {
        height: auto;
        padding-top: 36px;
        padding-bottom: 28px;
        background: url('/static/images/loyalty/domru-bonus/head-bg-mobile.png') 0 0 / cover no-repeat;
    }
`;

export const Row = styled(FlexBoxRow)`
    width: 100%;
    justify-content: space-between;
    align-items: center;
    flex-wrap: nowrap;

    @media (max-width: ${breakPoints.mobile}) {
        flex-direction: column-reverse;
    }
`;

export const Col = styled(FlexBoxCol)`
    display: flex;
    flex-direction: column;
    color: ${COLORS.white};
`;

export const Title = styled.h1`
    ${FONTS.H2};
    margin-bottom: 12px;

    @media (max-width: ${breakPoints.laptop}) {
        ${FONTS.H4};
        margin-bottom: 8px;
    }

    @media (max-width: ${breakPoints.mobile}) {
        ${FONTS.H3};
        margin-bottom: 4px;
    }
`;

export const SubTitle = styled.p`
    max-width: 400px;
    ${FONTS.XXL};
    margin-bottom: 24px;

    @media (max-width: ${breakPoints.laptop}) {
        max-width: 300px;
        ${FONTS.S};
        margin-bottom: 30px;
    }

    @media (max-width: ${breakPoints.mobile}) {
        max-width: unset;
        ${FONTS.M};
        margin-bottom: 28px;
    }
`;

export const Button = styled(BaseButton)`
    width: auto;
    max-width: 200px;

    @media (max-width: ${breakPoints.mobile}) {
        max-width: 100%;
    }
`;

export const Image = styled.img`
    width: 100%;
    max-width: 500px;
    height: auto;
    margin-top: 10%;

    @media (max-width: ${breakPoints.sDesktop}) {
        max-width: 360px;
        margin-top: 20%;
    }

    @media (max-width: ${breakPoints.laptop}) {
        max-width: 270px;
        margin-top: 10%;
    }

    @media (max-width: ${breakPoints.tablet}) {
        max-width: 230px;
        margin-top: 10%;
    }

    @media (max-width: ${breakPoints.mobile}) {
        max-width: 100%;
        margin-top: 0;
    }
`;
